const renamedLegacyPaths: Record<string, string> = {
  '/sharedwithme': '/shared-with-me',
  '/finma_communities': '/finma-communities',
  '/finma_registration': '/finma-registration',
};

export const redirectLegacyHashRoute = () => {
  const { pathname, hash, origin } = window.location;

  if ((pathname !== '/' && pathname !== '') || !hash.startsWith('#/')) {
    return;
  }

  const target = URL.parse(hash.slice(1), origin);

  if (target?.origin !== origin) {
    return;
  }

  window.history.replaceState(
    {},
    '',
    (renamedLegacyPaths[target.pathname] ?? target.pathname) +
      target.search +
      target.hash
  );
};
